import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CLUB_PROP_TYPES from '../lib/prop-types/club';
import { fetchContacts } from '../store/contact/actions';
import ContactPage from '../components/contact';
import {
  getClubLoadingError,
  getClubLocations,
  getOfficialGroups,
  getOtherOfficials,
  getOfficial,
  hasClubLoaded,
  isClubLoading,
} from '../store/contact/selectors';
import PageDataLoadError from '../components/errors/page-data-load-error';
import LOADING_ERROR_PROP_TYPES from '../lib/prop-types/loading-error';
import ClubRouter from '../lib/routing';
import { withTranslation } from '../lib/i18n';

class ContactPageController extends React.Component {
  static async getInitialProps({ club, isServer, query, reduxStore, req, res }) {
    const { officialId } = query;
    const initialProps = {
      activeSection: 'contact',
      namespacesRequired: ['common'],
      officialId: officialId ? parseInt(officialId, 10) : null,
      pageType: 'contact',
    };

    if (isServer) {
      const { error } = await reduxStore.dispatch(fetchContacts(club.id, req));

      if (error && error.errorStatusCode && res) {
        res.statusCode = error.errorStatusCode;
      }
    }

    return initialProps;
  }

  componentDidMount() {
    const { club, loadData, isLoading, previouslyLoaded, official, officialId } = this.props;

    if (!previouslyLoaded && !isLoading) {
      loadData(club.id);
    }

    if (officialId && !official) {
      ClubRouter.replaceClubRoute(club, 'contact');
    }
  }

  render() {
    const {
      isLoading,
      locations,
      officialGroups,
      otherOfficials,
      loadingError,
      club,
      official,
      t,
    } = this.props;

    if (loadingError) {
      return <PageDataLoadError clubId={club.id} {...loadingError} />;
    }

    return (
      <ContactPage
        club={club}
        isLoading={isLoading}
        locations={locations}
        officialGroups={officialGroups}
        otherOfficials={otherOfficials}
        official={official}
        t={t}
      />
    );
  }
}

ContactPageController.defaultProps = {
  loadingError: null,
  official: null,
  officialId: null,
};

ContactPageController.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadData: PropTypes.func.isRequired,
  loadingError: LOADING_ERROR_PROP_TYPES,
  locations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  officialGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  otherOfficials: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  previouslyLoaded: PropTypes.bool.isRequired,
  official: PropTypes.shape(),
  officialId: PropTypes.number,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: isClubLoading(state, ownProps.club.id),
  loadingError: getClubLoadingError(state, ownProps.club.id),
  locations: getClubLocations(state, ownProps.club.id),
  officialGroups: getOfficialGroups(state, ownProps.club.id),
  otherOfficials: getOtherOfficials(state, ownProps.club.id),
  previouslyLoaded: hasClubLoaded(state, ownProps.club.id),
  official: getOfficial(state, ownProps.club.id, ownProps.officialId),
});

const dispatchToProps = {
  loadData: fetchContacts,
};

export default connect(
  mapStateToProps,
  dispatchToProps,
)(withTranslation(['common'])(ContactPageController));
